import React from "react";

/** Small overlay showing the generated pseudo-syntax for the current
 * configuration, with a one-click copy — a readable record of the run. */
function SyntaxModal({ syntax, onClose, onCopy }) {
  return (
    <div className="syntax-modal-backdrop" onClick={onClose}>
      <div className="syntax-modal" onClick={(e) => e.stopPropagation()}>
        <div className="syntax-modal-header">
          <h4>Syntax</h4>
          <button className="syntax-modal-close" onClick={onClose} aria-label="Close">&times;</button>
        </div>
        <pre className="syntax-modal-body">{syntax}</pre>
        <div className="syntax-modal-actions">
          <button className="analysis-export-btn" onClick={onCopy}>Copy to clipboard</button>
        </div>
      </div>
    </div>
  );
}

export default SyntaxModal;
